import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0959a5a8"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "title"
};
var _hoisted_2 = {
  key: 0,
  "class": "description"
};
import { useQuestion } from '@/hooks/useQuestion';
import { t } from '@/lang';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'DTitle',
  setup: function setup(__props) {
    var _useQuestion = useQuestion(),
      title = _useQuestion.title,
      index = _useQuestion.index,
      is_necessary = _useQuestion.is_necessary,
      description = _useQuestion.description;
    var tt = computed(function () {
      return t().A14(index);
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", {
        "class": _normalizeClass(["no", {
          necessary: _unref(is_necessary)
        }])
      }, _toDisplayString(tt.value), 3), _createTextVNode(" . "), _createElementVNode("span", null, _toDisplayString(_unref(title)), 1), _renderSlot(_ctx.$slots, "default"), _unref(description) ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(description)), 1)) : _createCommentVNode("", true)]);
    };
  }
});